module.exports = __webpack_public_path__ + "img/geofenceEnter.8ce9d956.svg";